export enum LinearComboBetTracking {
    ParlayPositionEvent = 'parlay',
    SgpPositionEvent = 'sgp',
    HidePickListEventDetails = 'hide parlay',
    ViewPickListEventDetails = 'view parlay',
}

export const LinearComboExpandedLocalStorageKey = 'linearComboExpanded';

export const LinearComboSystemBetPositionEvent = 'Linear Combo Bet Info Popup';
export const LinearComboEventDetailsOpened = 'Combo Bet Info Icon Open';
export const LinearComboEventDetailsClosed = 'Combo Bet Info Icon Closed';
export const LinearComboActionEvent = 'Click';
